export default defineNuxtPlugin(() => {
  let isScreenActive = false;
  let lastHexCode = "";
  return {
    provide: {
      setLedLight: (hexCode: string) => {
        lastHexCode = hexCode;
        $fetch("http://localhost:8080/v2/hardware/light", {
          method: "POST",
          body: {
            id: 0,
            name: "frame",
            brightness: isScreenActive ? 1.0 : 0.0,
            color: hexCode,
          },
        }).catch((error) => {
          // eslint-disable-next-line no-console
          console.error("Error setting LED light color:", error);
        });
      },
      enableScreen: (enable: boolean) => {
        isScreenActive = enable;
        $fetch("http://localhost:8080/v2/hardware/display", {
          method: "POST",
          body: { id: 0, power: isScreenActive ? "on" : "standby" },
        }).catch((error) => {
          // eslint-disable-next-line no-console
          console.error("Error enabling/disabling screen:", error);
        });
        // if the screen is turned off, also turn off the LED light
        if (lastHexCode) {
          // also update the LED light color if it was set before
          useNuxtApp().$setLedLight(lastHexCode);
        }
      },
    },
  };
});
